import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Pagination } from "antd";
import { paymentWalletDetails } from "../../Data/PaymentDetailsData";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import WalletSkeleton from "../../components/skeleton/WalletSkeleton";
import { useThunk } from "../../hooks/useThunk";
import { fetchPaymentHistoryTasker, getTaskerProfile } from "../../store";
import { orderStatus, paymentHistoryTypes } from "../../constants/commonConstants";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import { currencyFormatter } from "../../utils/formatting";
import ErrorDisplay from "../../error/ErrorDisplay";

const Wallet = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const [activeTab, setActiveTab] = useState("ongoing");
  //const[ isLoading,setIsLoading]= useState(true);

  //fetch PaymentHistory
  const [doFetchPaymentHistoryTasker, isFetchPaymentHistoryTasker, fetchPaymentHistoryError] = useThunk(fetchPaymentHistoryTasker);
  const [doGetTaskerProfile, isGetTaskerProfile, getTaskerProfileError] = useThunk(getTaskerProfile);

  const [paymentHistoryData, setPaymentHistoryData] = useState();
  const [queryObj, setQueryObj] = useState({
    paymentType: paymentHistoryTypes.PAYMENT,
    offset: 0, 
    limit: itemsPerPage, 
    multipleStatus: [orderStatus.COMPLETED, orderStatus.IN_REVISION] 
  });
  const [taskerProfile, setTaskerProfile] = useState();
  const [totalDocuments, setTotalDocuments] = useState();
  

  // Simulate loading effect
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    //setTimeout(() => setIsLoading(false), 2000); // Simulate fetching data
    setQueryObj(prev => ({
      ...prev,
      offset: (currentPage-1)*itemsPerPage,
      limit: itemsPerPage
    }));
  }, [currentPage]);

  useEffect(() => {
    const fetchPaymentHistory = async (query) => {
    
      const response = await doFetchPaymentHistoryTasker(query);
      const data = response?.response?.data?.data;
      const paginationData = response?.response?.data?.pagination?.totalDocuments;
      console.log('fetched Payment History -', response);
    
      if(response?.success) {
        setPaymentHistoryData(data);
        setTotalDocuments(paginationData);
      }
    };

    fetchPaymentHistory(queryObj);
  },[queryObj]);

  useEffect(() => {
    const fetchTaskerProfile = async () => {
      const profile = await doGetTaskerProfile();
      if (profile?.success) {
        setTaskerProfile(profile?.response?.data);
      }
    };
    fetchTaskerProfile();
  }, []);
  

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    // setIsLoading(true);
    // setTimeout(()=>setIsLoading(false),2000);// Simulate fetching new data

    if(tab === 'ongoing') {
      setQueryObj(prev => ({
        ...prev,
        paymentType: paymentHistoryTypes.PAYMENT,
      }));
    } else {
      setQueryObj(prev => ({
        ...prev,
        paymentType: paymentHistoryTypes.PAYOUT,
      }));
    }

  };

  // const filteredPayments = paymentWalletDetails.filter(
  //   (payment) => payment.paymentStatus === activeTab
  // );

  // const paginatedPayments = filteredPayments.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  console.log('query object', queryObj);
  console.log('payment History Data', paymentHistoryData);


  return fetchPaymentHistoryError ? (
    <ErrorDisplay
      errorMessage={`${fetchPaymentHistoryError?.message || "Error occured fetching payment data"
        }`}
      buttonText="Back to HomePage"
      onButtonClick={() => navigate("/service-pro")}
    />
  ) : isFetchPaymentHistoryTasker ? (
    <WalletSkeleton />
  ) : (
    <div className="w-full min-w-[320px] mt-12 px-[20px] md:px-[40px] lg:px-[100px] mb-[88px]">
      <div className="bg-white border border-light-blue rounded-[20px] p-5 md:p-7 lg:p-9 flex flex-col gap-5 lg:gap-6">
        <div className=" flex flex-row flex-wrap justify-between items-center">
          <h1 className="mt-3 md:mb-0 mb-3 font-nonito_sans font-bold text-xl md:text-2xl lg:text-[32px] leading-[0.1%] text-dark">
            My Wallet
          </h1>
          <div className="flex flex-col items-center justify-center rounded-xl md:rounded-2xl gap-1 bg-[#FBC948] font-inter w-[140px] h-[62px] md:w-[200px] md:h-[82px]">
            <h1 className=" font-semibold text-[16px] md:text-[24px] text-content">
              { currencyFormatter.format(activeTab === 'ongoing' ? taskerProfile?.wallet?.pending : taskerProfile?.wallet?.amount ) } 
            </h1>
            <span className=" font-semibold text-[12px] text-[#0F161E]">{activeTab === 'ongoing' ? 'Total Pending' : 'Total Cleared'}</span>
          </div>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-row gap-4 border-b border-light-blue">
          <p
            className={`cursor-pointer font-nonito_sans lg:text-[1.125rem] text-[1rem] font-semibold ${
              activeTab === "ongoing"
                ? "border-b-[2px] pb-1 border-[var(--primary-color)]"
                : ""
            }`}
            onClick={() => handleTabChange("ongoing")}
          >
            Ongoing
          </p>
          <p
            className={`cursor-pointer font-nonito_sans lg:text-[1.125rem] text-[1rem] font-semibold  ${
              activeTab === "cleared"
                ? "border-b-[2px] pb-1 border-[var(--primary-color)]"
                : ""
            }`}
            onClick={() => handleTabChange("cleared")}
          >
            Cleared
          </p>
        </div>

        {/* Cards Section */}
        <div className="flex flex-col gap-4 lg:gap-6 md:gap-5">
          {paymentHistoryData?.length > 0 ? (
            paymentHistoryData?.map((payment) => (
              <div
                key={payment.id}
                className="flex flex-row rounded-[20px] py-4 px-6 border border-[#DDE1E6] gap-[24px] items-center cursor-pointer hover:bg-gray-100"
                onClick={() => {navigate(`/client/order-details/${payment?.order?._id || ""}`)}}
              >
                {/* star icon */}
                <div className="justify-center hidden md:block items-center">
                  <div className="w-[50px] h-[50px] bg-primary rounded-[8px] flex items-center justify-center">
                    <Star size={24} className="text-dark fill-dark" />{" "}
                  </div>
                </div>

                <div className="flex flex-col h-full  md:items-center justify-between w-full sm:flex-col md:flex-row lg:flex-row">
                  <div className="flex h-full  justify-center flex-col text-[16px] lg:text-[20px] leading-[30px] font-inter font-medium text-dark it">
                    <div className="flex flex-col sm:flex-row space-y-4 sm:space-x-4 md:space-x-0 sm:space-y-0">
                      <div className="justify-center items-center block md:hidden">
                        <div className="w-[50px] h-[50px] bg-primary rounded-[8px] flex items-center justify-center">
                          <Star size={24} className="text-dark fill-dark" />{" "}
                        </div>
                      </div>
                      <Link
                        // to={`/payment-details/${payment?.order?.id}`}
                        className="cursor-pointer"
                      >
                        {payment?.order?.id} &nbsp;&nbsp; {payment?.order?.title}
                      </Link>
                    </div>
                    <p className="text-[12px] lg:text-[14px] leading-[30px] text-content font-inter font-normal">
                      My Earning - {
                        currencyFormatter.format(
                          activeTab === 'ongoing'? payment?.taskerCommision : payment?.amount
                        )}
                    </p>
                  </div>
                  <div className="flex flex-col items-start md:items-end md:justify-end lg:items-end lg:justify-end leading-[30px] font-inter">
                    <p className="text-dark font-medium text-[16px] lg:text-[20px]">
                      {currencyFormatter.format(payment?.order?.price)}
                    </p>
                    <p className="text-content font-medium text-[12px] lg:text-[14px]">
                      Paid at {formatYYYY_MM_DD(payment?.createdAt)}
                    </p>
                    {activeTab === "cleared" && (
                      <p className="text-content font-medium text-[12px] lg:text-[14px]">
                        Completed at {formatYYYY_MM_DD(payment?.order?.completedDate)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-dark">No payments found.</p>
          )}
        </div>
      </div>

      {/* Pagination Component */}
      {totalDocuments > 0 && (
        <div className="flex justify-center mt-6">
          <Pagination
            current={currentPage}
            total={totalDocuments}
            pageSize={itemsPerPage}
            onChange={setCurrentPage}
            showSizeChanger={false}
            className="font-inter"
          />
        </div>
      )}
    </div>
  );
};

export default Wallet;
